module.exports = __webpack_public_path__ + "static/media/4.cc9d5432.jpg";